import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ImageZoom from '../ImageZoom';
import urlFormat from '../../utils/urlFormat';

const OtcSingle = ({ product, linkBase, style }) => {
  const [showZoom, setShowZoom] = useState(false);
  const imageUrl = product?.acf?.product_image?.url || 
                  product?.acf?.product_image?.sizes?.large || 
                  product?.acf?.image;

  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowZoom(true);
  };

  const handleCloseZoom = () => {
    setShowZoom(false);
    // Assurer que le scroll est réactivé
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <Link
        key={`OTC_${product.name?.toLowerCase() || product.id}`}
        className="single_otc"
        to={`${linkBase}/${urlFormat(product.name || product.acf?.title_fr)}`}
        style={style}
      >
        {imageUrl && (
          <div
            className="image"
            style={{ backgroundImage: `url("${imageUrl}")` }}
            onClick={handleImageClick}
            role="button"
            aria-label="Agrandir l'image"
          />
        )}
        {!imageUrl && <div className="image" />}
        <div className="text">
          <p className="title">{product.acf.title_fr}</p>
          {product.acf.potency && <p className="potency">{product.acf.potency}</p>}
        </div>
      </Link>

      {showZoom && imageUrl && (
        <ImageZoom imageUrl={imageUrl} onClose={handleCloseZoom} />
      )}
    </>
  );
};

OtcSingle.propTypes = {
  product: PropTypes.object.isRequired,
  linkBase: PropTypes.string.isRequired,
  style: PropTypes.object
};

export default OtcSingle;
